<template>
  <div class="terminos-container">
    <div class="terminos-content">
      <h1 class="text-center mb-4">Términos y Condiciones del Carpinclub de Carpincentro</h1>

      <div class="intro mb-4">
        <p class="lead">
          Bienvenido al Carpinclub, la comunidad de beneficios de Carpincentro! Queremos que disfrutes cada recompensa con total claridad. Estos términos explican cómo funciona el programa y las reglas que lo mantienen justo y transparente para todos.
        </p>
        <p>
          La participación en Carpinclub implica la aceptación voluntaria de estos Términos. Esta disposición no afecta los derechos irrenunciables de los consumidores conforme a la legislación colombiana vigente.
        </p>
      </div>

      <section class="mb-5">
        <h2>1. Inscripción y acceso</h2>
        <p><strong>Gratis y sencilla.</strong> Puedes unirte en cualquier punto de venta Carpincentro o a través del formulario en línea disponible en <a href="https://app.carpincentro.com/verif-carpinclub" target="_blank">https://app.carpincentro.com/verif-carpinclub</a>.</p>

        <p><strong>Datos al día.</strong> Para activar tu cuenta necesitamos tu nombre real, número de cédula o NIT, celular y correo válidos. <strong>Tu aprobación.</strong> Al registrarte autorizas el tratamiento de tus datos de acuerdo con la Política de Privacidad de ARDISA S.A.</p>

        <div class="alert alert-info">
          <strong>Importante:</strong> Para completar tu inscripción debes validar tu celular y correo electrónico dando clic en los enlaces que recibirás por SMS y correo. Solo así activaremos correctamente tu cuenta. Es clave, porque allí recibirás avisos de puntos, redenciones y novedades.
        </div>
      </section>

      <section class="mb-5">
        <h2>2. Acumulación de puntos</h2>
        <p>Al ser parte de Carpinclub acumulas puntos por tus compras en Carpincentro. En ocasiones especiales, algunos productos o campañas ofrecerán multiplicadores de puntos que te permitirán acumular más rápido.</p>
        <p>Los puntos se cargan al momento de la compra mostrando tu cédula o NIT. No podemos acreditar puntos de compras realizadas antes de tu inscripción.</p>
        <p>Carpincentro podrá modificar, suspender o cancelar, en cualquier momento y sin previo aviso, la acumulación de puntos o el programa en su totalidad, por razones operativas o comerciales.</p>
      </section>

      <section class="mb-5">
        <h2>3. Niveles y evolución</h2>
        <p>El Carpinclub tiene niveles pensados para reconocer tu fidelidad; cuanto más compres, mejores beneficios obtienes. Según la cantidad de puntos acumulados, podrás pertenecer a cualquiera de las siguientes categorías:</p>

        <div class="niveles-list">
          <div class="nivel-item mb-3">
            <h3 class="h5">Socio</h3>
            <p>Pertenecerán a esta categoría los clientes al momento de inscribirse. Desde ese momento comienzan a acumular puntos y pueden ascender a niveles superiores en cualquier momento, según el recálculo automático diario del programa.</p>
          </div>

          <div class="nivel-item mb-3">
            <h3 class="h5">Socio Plata</h3>
            <p>Pertenecerán a este nivel los socios que acumulen entre <strong>5.400 y 17.999 puntos</strong> en el trimestre. Si el miembro no vuelve a reunir los puntos requeridos en el siguiente trimestre, su nivel descenderá un nivel.</p>
          </div>

          <div class="nivel-item mb-3">
            <h3 class="h5">Socio Oro</h3>
            <p>Pertenecerán a este nivel los socios que acumulen entre <strong>18.000 y 38.999 puntos</strong> en el trimestre. Si el miembro no vuelve a reunir los puntos requeridos en el siguiente trimestre, su nivel descenderá un nivel.</p>
          </div>

          <div class="nivel-item mb-3">
            <h3 class="h5">Socio Diamante</h3>
            <p>Pertenecerán a este nivel los socios que acumulen <strong>39.000 puntos o más</strong> al finalizar el trimestre. Los Socios Diamante reciben los máximos beneficios y ventajas exclusivas dentro del programa. Si el miembro no vuelve a reunir los puntos requeridos en el siguiente trimestre, su nivel descenderá un nivel.</p>
          </div>
        </div>

        <p>El nivel se recalcula automáticamente al cierre de cada trimestre. Tras ascender, conservarás al menos ese nivel durante el trimestre siguiente. Durante el mismo año calendario, tu nivel solo descenderá un escalón por trimestre, incluso si tu acumulado es inferior, como beneficio del club.</p>
        <p>Los rangos de puntos podrán revisarse cada trimestre para adaptar el programa a nuevas dinámicas del mercado.</p>
      </section>

      <section class="mb-5">
        <h2>4. Redención de puntos y recompensas</h2>
        <p>Tus puntos Carpinclub pueden canjearse por recompensas exclusivas, como dinero digital ("CarpinCash" o "CarpinBarra") que podrás usar como medio de pago en Carpincentro y Ardisa.</p>

        <h3 class="h5 mt-4 mb-3">Algunos ejemplos de redención son:</h3>
        <ul class="ejemplos-redencion">
          <li>Redime <strong>50.000 puntos</strong> por <strong>$50.000</strong> CarpinCash</li>
          <li>Redime <strong>100.000 puntos</strong> por <strong>$90.000</strong> CarpinCash</li>
          <li>Redime <strong>300.000 puntos</strong> por una lámina de melamina Spar</li>
        </ul>

        <p>Los premios o productos disponibles podrán variar según campañas, temporadas o inventario. Todas las redenciones estarán disponibles hasta agotar existencias y podrán modificarse sin previo aviso. El CarpinCash podrá utilizarse únicamente en las marcas participantes o según las condiciones vigentes establecidas por Carpincentro.</p>

        <p>Los puntos no tienen valor en efectivo, no pueden canjearse por dinero ni transferirse a otras personas. Tampoco podrán usarse como pago de cartera, impuestos, transporte o saldos pendientes.</p>

        <p>En cada redención recibirás una confirmación por SMS. Si no reconoces la transacción, comunícate de inmediato con nosotros.</p>

        <p>Carpincentro podrá ofrecer, a su discreción, recompensas especiales, promociones o experiencias de temporada, así como catálogos de premios o productos no habituales disponibles por tiempo limitado y hasta agotar existencias, los cuales se asignarán por orden de solicitud, es decir, a los primeros en solicitarlos y canjearlos por sus puntos.</p>
      </section>

      <section class="mb-5">
        <h2>5. Mantenimiento de cuenta activa y vigencia de puntos</h2>
        <p>En Carpinclub queremos que pertenecer siga siendo algo especial. Este es un espacio para quienes disfrutan crecer con nosotros, aprovechar sus beneficios y hacer parte de una comunidad que valora su constancia.</p>

        <p>Por eso, para mantener viva tu membresía y seguir disfrutando de tus beneficios, es importante mantener tu cuenta activa. Si durante un tiempo no realizas compras, tu cuenta y puntos podrán caducar de la siguiente manera:</p>

        <ul class="caducidad-puntos">
          <li>Después de <strong>3 meses consecutivos sin compras</strong>, caducará el <strong>50%</strong> de los puntos vigentes en tu cuenta.</li>
          <li>Cada <strong>3 meses consecutivos adicionales sin compras</strong>, se volverá a revisar el saldo restante y caducará nuevamente el <strong>50%</strong> de los puntos vigentes en ese momento.</li>
        </ul>

        <p>Esto significa que la caducidad se aplica siempre sobre los puntos que queden en tu saldo en cada revisión, hasta que vuelvas a realizar una compra. Con solo una compra dentro del periodo de 3 meses, tu cuenta se considera activa.</p>

        <div class="alert alert-warning">
          <strong>Importante:</strong> Cada <strong>31 de diciembre</strong>, todos los puntos no redimidos durante el año expirarán automáticamente, sin excepción.
        </div>

        <p>Mantenerte activo no solo conserva tus puntos: te permite seguir siendo parte de un grupo de socios que disfrutan beneficios exclusivos y recompensas creadas especialmente para quienes confían en Carpincentro día a día.</p>
      </section>

      <section class="mb-5">
        <h2>6. Cambios, suspensión o terminación del programa y cierre de cuenta</h2>

        <h3 class="h5 mt-4 mb-3">Cambios en el programa</h3>
        <p>Carpincentro podrá, a su discreción, modificar, limitar o ajustar las reglas, beneficios, condiciones de acumulación o redención de puntos, niveles de membresía, elegibilidad, o cualquier otra característica del programa Carpinclub en cualquier momento.</p>
        <p>Tu participación continua en el programa después de la publicación de los cambios implica tu aceptación expresa de las nuevas condiciones.</p>
        <p>En caso de terminación definitiva del programa, Carpincentro informará el proceso y plazo para redimir los puntos acumulados antes de su vencimiento.</p>

        <h3 class="h5 mt-4 mb-3">Suspensión o exclusión de miembros</h3>
        <p>Carpincentro se reserva el derecho de excluir a cualquier participante del programa, suspender su cuenta o eliminar puntos acumulados si se detecta:</p>
        <ul>
          <li>Uso indebido, manipulación o fraude del programa o sus beneficios.</li>
          <li>Creación de múltiples cuentas para un mismo cliente.</li>
          <li>Creación de cuentas por parte de mayoristas o ferreteros.</li>
          <li>Reventa o transferencia no autorizada de beneficios, premios o puntos.</li>
          <li>Incumplimiento de los Términos y Condiciones del programa.</li>
          <li>Inactividad de la cuenta por más de seis (6) meses consecutivos.</li>
          <li>Conductas que perjudiquen la operación, reputación o intereses de Carpincentro.</li>
        </ul>
        <p>En tales casos, Carpincentro podrá cancelar los puntos acumulados de manera inmediata y revocar la participación futura del cliente en el programa.</p>

        <h3 class="h5 mt-4 mb-3">Cierre de cuenta</h3>
        <p>Si deseas cerrar tu cuenta, puedes solicitarlo a través del servicio al cliente de Carpincentro. Ten en cuenta que el cierre implica:</p>
        <ul>
          <li>Eliminación de todos los puntos acumulados y beneficios activos.</li>
          <li>Pérdida de acceso a los niveles de membresía y beneficios asociados.</li>
          <li>Imposibilidad de acumular nuevos puntos.</li>
        </ul>
      </section>

      <section class="mb-5">
        <h2>7. Tratamiento de datos personales</h2>
        <p>Al participar en el Carpinclub y diligenciar el formulario de inscripción, declaras haber leído y aceptado la Política de Tratamiento de Datos Personales de ARDISA S.A., disponible en nuestros canales oficiales y en el formulario de inscripción.</p>

        <p>La activación de tu membresía -mediante la verificación del correo electrónico y número de celular registrados- constituye la confirmación de que fuiste tú quien realizó la inscripción y otorgó tu consentimiento para el tratamiento de tus datos personales.</p>

        <p>Al hacerlo, autorizas a ARDISA S.A. a tratar tus datos para:</p>
        <ul>
          <li>Administrar tu participación en el programa Carpinclub.</li>
          <li>Enviarte información sobre tus puntos, redenciones, beneficios, promociones y novedades.</li>
        </ul>

        <p>Esta autorización se considera expresa y prevalece sobre cualquier inscripción en registros de exclusión publicitaria o similares, en la medida en que se limita al envío de información relacionada con tu membresía activa en el programa.</p>

        <p>Puedes ejercer en cualquier momento tus derechos de acceso, actualización, rectificación o supresión de tus datos escribiendo a <a href="mailto:habeasdata@ardisa.com">habeasdata@ardisa.com</a>.</p>
      </section>

      <section class="mb-5">
        <h2>8. Notificaciones oficiales</h2>
        <p>Toda comunicación relacionada con tu cuenta (avisos de vencimiento, extractos de puntos, novedades) se enviará al correo electrónico y/o celular registrados. Mantener estos datos actualizados es tu responsabilidad.</p>
      </section>

      <section class="mb-5">
        <h2>9. Contacto y ayuda</h2>
        <p>¿Tienes preguntas, sugerencias o simplemente quieres contarnos tu experiencia como parte del Carpinclub? Nos encanta escuchar a nuestra comunidad.</p>
        <p>Escríbenos por Instagram a <a href="https://instagram.com/carpincentro.ardisa" target="_blank">@carpincentro.ardisa</a> o al correo <a href="mailto:ayuda@ardisa.com">ayuda@ardisa.com</a>.</p>
        <p>Estamos aquí para acompañarte, resolver tus inquietudes y seguir construyendo juntos una comunidad donde cada socio aporta a que el club crezca y se fortalezca.</p>
      </section>

      <div class="footer-message text-center mt-5 pt-4 border-top">
        <p class="lead mb-2">Gracias por ser parte del Carpinclub de Carpincentro.</p>
        <p class="text-muted">Porque más que un programa, somos una comunidad que comparte la pasión por crear y transformar vidas.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TerminosYCondiciones'
}
</script>

<style scoped>
  .terminos-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
  }

  .terminos-content {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  h1 {
    color: var(--primary-color);
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  h2 {
    color: var(--primary-color);
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 2rem;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid var(--primary-color);
  }

  h3 {
    color: var(--primary-color);
    font-weight: 600;
  }

  .intro {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 5px;
    border-left: 4px solid var(--primary-color);
  }

  .lead {
    font-size: 1.1rem;
    font-weight: 500;
  }

  section {
    line-height: 1.8;
  }

  section p {
    margin-bottom: 1rem;
    text-align: justify;
  }

  .niveles-list {
    margin: 1.5rem 0;
  }

  .nivel-item {
    padding: 15px;
    background-color: #f8f9fa;
    border-left: 4px solid var(--primary-color);
    border-radius: 4px;
  }

  .nivel-item h3 {
    margin-bottom: 0.5rem;
    color: var(--primary-color);
  }

  .ejemplos-redencion {
    list-style-type: none;
    padding-left: 0;
  }

  .ejemplos-redencion li {
    padding: 10px;
    margin-bottom: 8px;
    background-color: #f8f9fa;
    border-left: 3px solid var(--secondary-color);
    padding-left: 15px;
  }

  .caducidad-puntos {
    margin: 1rem 0;
  }

  .caducidad-puntos li {
    margin-bottom: 0.8rem;
  }

  ul {
    padding-left: 1.5rem;
  }

  ul li {
    margin-bottom: 0.5rem;
  }

  a {
    color: var(--primary-color);
    text-decoration: underline;
  }

  a:hover {
    color: #161f3d;
  }

  .alert {
    padding: 15px;
    margin: 1.5rem 0;
    border-radius: 5px;
    border-left: 4px solid;
  }

  .alert-info {
    background-color: #d1ecf1;
    border-color: #0c5460;
    color: #0c5460;
  }

  .alert-warning {
    background-color: #fff3cd;
    border-color: #856404;
    color: #856404;
  }

  .footer-message {
    margin-top: 3rem;
    padding-top: 2rem;
  }

  .footer-message .lead {
    color: var(--primary-color);
    font-weight: 600;
  }

  @media (max-width: 768px) {
    .terminos-container {
      padding: 10px;
    }

    .terminos-content {
      padding: 20px;
    }

    h1 {
      font-size: 1.5rem;
    }

    h2 {
      font-size: 1.25rem;
    }
  }
</style>
